/**
 * Helles und dunkles Erscheinungsbild.
 *
 * Die Farben stecken alle in den Variablen von styles.css; hier wird nur
 * umgeschaltet, gespeichert und die Adressleiste des Browsers nachgezogen.
 * Hell ist der Standard – siehe auch das kleine Skript in index.html, das
 * das Theme schon vor dem ersten Bild setzt.
 */

const KEY = "ju-theme";
const BAR = { light: "#f6f7f3", dark: "#0e1113" };

export const DEFAULT_THEME = "light";

export function readTheme() {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    /* Privates Fenster ohne Speicher: dann eben der Standard. */
  }
  return DEFAULT_THEME;
}

export function applyTheme(theme) {
  const next = theme === "dark" ? "dark" : "light";
  document.documentElement.dataset.theme = next;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", BAR[next]);
  try {
    localStorage.setItem(KEY, next);
  } catch {
    /* Ohne Speicher gilt die Wahl nur für diesen Besuch. */
  }
  return next;
}
